import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(activity)/candy-glasses/animations.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/Banner1Animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/BottomBanner.m.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/BottomBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/CandyNav.p.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/CandyProducts.m.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/CandyProducts.p.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/CandyTopBanner.m.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/CandyTopBanner.p.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/PhotoWall.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/candy-glasses/components/ScrollAnimationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
